import React, { useEffect, useRef } from 'react';
import './WaveTitle.css';

const WaveTitle = () => {
  const ref = useRef(null);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (ref.current) ref.current.classList.add('show');
    }, 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="wave-title-wrapper">
      <div className="wave-title" ref={ref}>
        <div className="line-1">LEARN BUILD</div>
        <div className="line-2">GET HIRED</div>
      </div>
    </div>
  );
};

export default WaveTitle;
